import { InjectionToken } from '@angular/core';
import { Observable } from 'rxjs';

import { ApplicationUser } from '../models/classes/users/ApplicationUser';

/**
 * The authentication service injection token.
 */
export const USERS_SERVICE = new InjectionToken<IUsersService>('USERS_SERVICE');

export interface IUsersService {
    getCurrentUser(): Observable<ApplicationUser>;
}